<div class="profile-container">
  <mat-card *ngIf="!loading" class="profile-card">
    <mat-card-header>
      <mat-card-title>User Profile</mat-card-title>
    </mat-card-header>
    <mat-card-content *ngIf="profile">
      <mat-list>
        <mat-list-item class="profile-item">
          <mat-icon matListItemIcon>person</mat-icon>
          <div matListItemTitle>{{ profile.firstName }} {{ profile.lastName }}</div>
          <div matListItemLine>{{ profile.email }}</div>
        </mat-list-item>

        <mat-list-item class="profile-item">
          <mat-icon matListItemIcon>phone</mat-icon>
          <div matListItemTitle>Phone Number</div>
          <div matListItemLine>{{ profile.phoneNumber }}</div>
        </mat-list-item>

        <mat-list-item class="profile-item">
          <mat-icon matListItemIcon>badge</mat-icon>
          <div matListItemTitle>Role</div>
          <div matListItemLine>{{ profile.role.name }}</div>
        </mat-list-item>

        <mat-list-item class="profile-item">
          <mat-icon matListItemIcon>description</mat-icon>
          <div matListItemTitle>Role Description</div>
          <div matListItemLine>{{ profile.role.description }}</div>
        </mat-list-item>

        <mat-list-item class="profile-item">
          <mat-icon matListItemIcon>login</mat-icon>
          <div matListItemTitle>Last Login</div>
          <div matListItemLine>{{ profile.lastLogin | date: 'medium' }}</div>
        </mat-list-item>
      </mat-list>
    </mat-card-content>
  </mat-card>

  <div *ngIf="loading" class="loading-spinner">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
</div>